import { ShieldCheck } from "lucide-react";
import GummyBurger from "./GummyBurger";

const BG_BY_VARIANT = {
  classic: "bg-bun-soft",
  max: "bg-patty-soft",
  love: "bg-berry-soft",
};

export default function ProductCard({ product, detailed = false }) {
  return (
    <article data-testid={product.testid} className="card-gummy flex flex-col">
      <div
        className={`flex items-center justify-center rounded-2xl ${BG_BY_VARIANT[product.variant]} px-6 py-8`}
      >
        <GummyBurger
          variant={product.variant}
          className="w-40 animate-float-slow sm:w-44"
          title={`Ilustrasi ${product.name}`}
        />
      </div>

      <div className="mt-5 flex flex-wrap items-center gap-2">
        <span className="rounded-full bg-plum px-3 py-1 text-xs font-bold uppercase tracking-wider text-white">
          {product.badge}
        </span>
        <span className="inline-flex items-center gap-1 rounded-full bg-lettuce-soft px-3 py-1 text-xs font-bold uppercase tracking-wider text-lettuce-dark">
          <ShieldCheck className="h-3.5 w-3.5" aria-hidden="true" />
          Halal
        </span>
      </div>

      <h3 className="mt-4 font-display text-xl font-bold text-plum sm:text-2xl">{product.name}</h3>
      <p className="mt-1 font-display text-sm font-semibold text-bun-dark">{product.tagline}</p>
      <p className="mt-3 flex-1 text-sm leading-relaxed text-plum-soft">{product.description}</p>

      {detailed && (
        <dl className="mt-5 space-y-2.5 border-t-2 border-dashed border-plum/10 pt-5 text-sm">
          <div className="flex gap-2">
            <dt className="w-24 shrink-0 font-bold text-plum">Tekstur</dt>
            <dd className="text-plum-soft">{product.texture}</dd>
          </div>
          <div className="flex gap-2">
            <dt className="w-24 shrink-0 font-bold text-plum">Lapisan</dt>
            <dd className="text-plum-soft">{product.layers}</dd>
          </div>
          <div className="flex gap-2">
            <dt className="w-24 shrink-0 font-bold text-plum">Cocok untuk</dt>
            <dd className="text-plum-soft">{product.cocok}</dd>
          </div>
        </dl>
      )}
    </article>
  );
}
